export const profile = {
  name: 'Kat Díaz',
  location: 'Medellín, Colombia',
  email: 'kat@sukikatu.com',
  logo: 'https://cdn.magicpatterns.com/uploads/9NSKsVgBNz6sAmwJVsHGbA/sukikatu-favicon-192x192.png',
  portrait: 'https://cdn.magicpatterns.com/uploads/qhLyPygcNo4rJUH8cCvmtP/kGefQxNnMb6TFtuxZnMIgfYKUyo.avif',
  portraitAlt: 'Kat Díaz at a café, holding a cup of coffee',
  portraitCaption: 'Coffee, psychology papers and prototypes. Based in Medellín.',
  talkPhoto: 'https://cdn.magicpatterns.com/uploads/pc89cMGvqZiYWefSX1kGKw/IMG_1608.jpg',
  talkPhotoAlt: 'Kat speaking at a podium at Universidad EAFIT, in front of a slide reading "Memoria, no carpeta bonita"',
  // Paste the URL of your CV (PDF) here. Until then, "Download CV" opens an email asking for it.
  // Google Drive direct-download link for the CV (file id 1kKpDbIk89KtvdC1HBvJPcBQfRWRqZEH1).
  cv: 'https://drive.google.com/uc?export=download&id=1kKpDbIk89KtvdC1HBvJPcBQfRWRqZEH1' as string,
  linkedin: 'https://www.linkedin.com/in/sukikatu',
  github: 'https://github.com/sukikatu',
  medium: 'https://medium.com/@sukikatu',
  dribbble: 'https://dribbble.com/sukikatu'
};
export const cvHref = profile.cv || `mailto:${profile.email}?subject=${encodeURIComponent('CV request')}`;
export const navItems = [{
  id: 'top',
  label: 'Home',
  index: ''
}, {
  id: 'work',
  label: 'Case studies',
  index: '01'
}, {
  id: 'writing',
  label: 'Writing & talks',
  index: '02'
}, {
  id: 'playground',
  label: 'Playground',
  index: '03'
}, {
  id: 'contact',
  label: 'Contact',
  index: '04'
}];
export const socialLinks = [{
  label: 'LinkedIn',
  href: profile.linkedin
}, {
  label: 'GitHub',
  href: profile.github
}, {
  label: 'Dribbble',
  href: profile.dribbble
}, {
  label: 'Medium',
  href: profile.medium
}];
export const clients = ['Adidas', 'Ralph Lauren', 'Palacio de Hierro', 'Allergan', 'Bancolombia', 'Mastercard'];
export const principles = [{
  number: '01',
  title: 'Behavior over opinions',
  body: "Users can't predict themselves. I look at what they actually do, find the gap between intention and action, and design for that."
}, {
  number: '02',
  title: 'Complex, regulated, high trust',
  body: 'Lending, payments, accounting and AI agents for finance teams. I like domains where clarity is hard to get right.'
}, {
  number: '03',
  title: 'Prototype in code, early',
  body: 'I prototype with AI tools to learn faster, moving from idea to something real in days, not a static file in weeks.'
}];
